<script setup lang="ts">
import { faCloudBinary } from '@fortawesome/pro-solid-svg-icons';
import { GpTag } from '@gportal/uikit';
import getEnumLabel from 'gpcore-apikit/lib/getEnumLabel';
import { CloudProviderType } from 'gpcore-grpc/gpcore/type/v1/cloud_provider_pb';
import AwsIcon from 'gpcore-uikit/icons/aws.vue';
import TencentIcon from 'gpcore-uikit/icons/tencent.vue';
import { computed } from 'vue';

type Props = {
  providerType?: CloudProviderType;
  hideLabel?: boolean;
  size?: 'extra-small' | 'small' | 'large';
};

const {
  providerType = CloudProviderType.UNSPECIFIED,
  hideLabel = false,
  size = 'small',
} = defineProps<Props>();

const label = computed(() => getEnumLabel(CloudProviderType, providerType));

const sizeClasses = computed<{
  iconSize: string;
}>(() => {
  switch (size) {
    case 'extra-small':
      return {
        iconSize: 'tw-h-3 tw-w-3',
      };
    case 'large':
      return {
        iconSize: 'tw-h-6 tw-w-6',
      };
    default:
      return {
        iconSize: 'tw-h-4 tw-w-4',
      };
  }
});

const iconClass = computed(() => {
  const iconClasses: string[] = ['tw-inline-block'];
  iconClasses.push(sizeClasses.value.iconSize);

  if (!hideLabel) {
    if (size === 'extra-small') {
      iconClasses.push('tw-mr-1');
    } else {
      iconClasses.push('tw-mr-2');
    }
  }

  return iconClasses.join(' ');
});
</script>

<template>
  <GpTag
    v-if="providerType != CloudProviderType.UNSPECIFIED"
    class="tw-inlin-flex tw-items-center tw-rounded-full tw-text-center"
    hover
    :size="size"
    :class="{
      'tw-w-component-base !tw-px-0': hideLabel,
    }"
  >
    <TencentIcon v-if="providerType === CloudProviderType.TENCENT" :class="iconClass" />
    <AwsIcon v-else-if="providerType === CloudProviderType.AWS" :class="iconClass" />

    <template v-if="!hideLabel">
      {{ label }}
    </template>
  </GpTag>

  <GpTag
    v-else
    :label="hideLabel ? undefined : 'Unknown'"
    :size="size"
    class="tw-rounded-full tw-uppercase"
    :icon="faCloudBinary"
  />
</template>

<style scoped></style>
